import styled from "styled-components";
import { Params } from "./types";

export const ImageLogo = styled.img<Params>`
    height: ${(props) => props.height};
    margin: 10px;
`;
